import { render, staticRenderFns } from "./TenantSettingsView.vue?vue&type=template&id=16fdd9a2&scoped=true"
import script from "./TenantSettingsView.vue?vue&type=script&lang=js"
export * from "./TenantSettingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fdd9a2",
  null
  
)

export default component.exports